"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MULTIPROOF_STRATEGY = exports.POLL_CHOICE_MAX = exports.POLL_QUESTION_MAX = void 0;
exports.POLL_QUESTION_MAX = 20;
exports.POLL_CHOICE_MAX = 75;
exports.MULTIPROOF_STRATEGY = 'multiproof';
